module.exports = __webpack_public_path__ + "static/media/neumaticos.4c56c3f3.png";